import { useEffect, useState } from "react";
import { useLabels, useMapCore } from "../hooks";
import { Button } from "../primitives/Button";

export type LocateButtonProps = { className?: string };

export function LocateButton({ className }: LocateButtonProps) {
  const core = useMapCore();
  const labels = useLabels();
  const [active, setActive] = useState(false);

  useEffect(() => core.on("error", () => setActive(false)), [core]);

  return (
    <Button
      kind="icon"
      size="lg"
      icon="locate"
      label={labels.locate}
      className={["fxmap-locate-button", active ? "fxmap-locate-active" : "", className ?? ""].filter(Boolean).join(" ")}
      data-fxmap="locate"
      pressed={active}
      onClick={() => {
        if (active) core.view.stopLocate();
        else core.view.locate();

        setActive(!active);
      }}
    />
  );
}
